import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CodebookService } from 'src/services/codebook.service';

@Component({
  selector: 'app-service-provider-assessment-contact-person-dialog',
  templateUrl: './service-provider-assessment-contact-person-dialog.component.html',
  styleUrls: ['./service-provider-assessment-contact-person-dialog.component.scss']
})
export class ServiceProviderAssessmentContactPersonDialogComponent implements OnInit {

  contactForm: FormGroup;
  relationshipOptions = [];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ServiceProviderAssessmentContactPersonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private codebook: CodebookService,
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      kinship: ['', Validators.required],
      address: ['', Validators.required],
      phone: ['', [Validators.minLength(9), Validators.maxLength(13), Validators.pattern('^[0-9]*$')]],
      email: ['', [Validators.email]]
    });

    this.codebook.getRelationshipCodebookWithoutUser().subscribe(result => {
      this.relationshipOptions = result;
    });

    if (this.data) {
      this.contactForm.patchValue(this.data);
    }
  }

  compareRelationshipObjects(object1: any, object2: any) {
    return object1 && object2 && object1.id === object2.id && object1.title === object2.title;
  }

  save() {
    if (this.contactForm.valid) {
      this.dialogRef.close(this.contactForm.value);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
